import { getOrCreateAnonymousKey } from './anonymousKey';

// The anonymous LaunchDarkly context the Hub initialises with. Shared with the flag cache reader,
// which finds the SDK's cached flags by this exact context.
export function hubLdContext(preview: boolean) {
  return { kind: 'user', anonymous: true, key: getOrCreateAnonymousKey(), preview };
}
